<div class="success-dialog">
  <div>
    <div class="illustration-wrap" *ngIf="illustration">
      <img [src]="illustration" alt="Dialog illustration" class="dialog-illustration" />
    </div>
    <div class="title-wrap">
      <h2>{{ title }}</h2>
      <span class="subTitle" [innerHTML]="body"></span>
    </div>
    <div class="wrap-button">
      <lib-button (click)="close()" [label]="closeText" type="Secondary" [widthFull]="true">
        {{ closeText }}
      </lib-button>
      <lib-button *ngIf="confirmText !== 'Contact Helpdesk'" (click)="confirm()" [label]="confirmText"
        [widthFull]="true"></lib-button>
      <a style="text-decoration: none" *ngIf="confirmText === 'Contact Helpdesk'"
        href="mailto:helpdesk@pivot-payment.com">
        <lib-button [label]="confirmText" type="Primary"></lib-button>
      </a>
    </div>
  </div>
</div>